// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"delete-confirmation-modal_modalContainer__3m6pS","modalBody":"delete-confirmation-modal_modalBody__3P447"};